import React from "react";
import { useTranslation } from "react-i18next";
import { useListRemoval } from "@planzone/view-models";
import { Button } from "@common/button";
import { Modal } from "@common/modal";
import { Props } from "./types";
import { ListsList } from "./listsList";
import styles from "./styles.scss";

function ListRemoval({ list, cancel }: Props) {
  const { t } = useTranslation();
  const { isRequestPending, removeList } = useListRemoval(list);

  return (
    <Modal
      className={styles.listRemoval}
      headerClassName={styles.header}
      header={t("removeList.title")}
      close={cancel}
    >
      <div className={styles.main}>
        <p className={styles.message}>
          {list.tasks.length + list.subLists.length > 0
            ? t("removeList.plural")
            : t("removeList.singular")}
          :
        </p>
        <div className={styles.list}>
          <ListsList list={list} />
        </div>
        <div className={styles.buttons}>
          <Button type="cancel" press={cancel}>
            {t("removeList.cancel")}
          </Button>
          <Button
            type="delete"
            status={isRequestPending ? "pending" : "none"}
            press={() => removeList(list)}
          >
            {t("removeList.confirm")}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export { ListRemoval };
